import styles from "../landing-page-four.module.css";

interface ExamplesSectionProps {
  onClickExample: () => void;
}

export const ExamplesSection = (props: ExamplesSectionProps) => {
  return (
    <div className={styles.sectionContainer}>
      <div className={styles.exampleImagesContainer}>
        <img
          className={styles.exampleImage}
          src="/landing-page/landing-four/example-6.png"
          alt="Example 1"
          onClick={props.onClickExample}
        />
        <img
          className={styles.exampleImage}
          src="/landing-page/landing-four/example-8.jpg"
          alt="Example 2"
          onClick={props.onClickExample}
        />
        <img
          className={styles.exampleImage}
          src="/landing-page/landing-four/example-3.jpg"
          alt="Example 3"
          onClick={props.onClickExample}
        />
        <img
          className={styles.exampleImage}
          src="/landing-page/landing-four/example-7.jpeg"
          alt="Example 4"
          onClick={props.onClickExample}
        />
      </div>
    </div>
  );
};
